const missions = ["Launch", "Sunshield deployment", "Mirror deployments", "Arrival at L2", "Telescope cooling", "Telescope alignment", "Instruments calibration", "First image"]

export default missions